import { render, staticRenderFns } from "./Luck.vue?vue&type=template&id=3f898610&scoped=true"
import script from "./Luck.vue?vue&type=script&lang=js"
export * from "./Luck.vue?vue&type=script&lang=js"
import style0 from "./Luck.vue?vue&type=style&index=0&id=3f898610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f898610",
  null
  
)

export default component.exports